var React = require('react');

function IcCaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 10L12 14L16 10H8Z","fill":"currentColor"}));
}

IcCaretDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcCaretDown;

IcCaretDown.default = IcCaretDown;
